export default "__VITE_ASSET__B7lO4Rfl__"